import { ReactNode, useMemo } from 'react';
import { css } from '@bts-web/utils-style-engine';
import Link from 'next/link';
import { AccordionContentImage } from './AccordionContentImage';

export type ContentProps = {
  title: string;
  titleBadge?: ReactNode;
  subtitle?: string;
  image: string | ReactNode;
  fallbackImage?: string;
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  id?: string;
};

export const AccordionContent = ({
  title,
  titleBadge,
  subtitle,
  image,
  fallbackImage,
  onClick,
  href,
  id,
  children,
}: ContentProps) => {
  const commonProps = useMemo(
    () => ({
      'data-testid': 'content-container',
      'data-element': 'content-container',
      ...(onClick && { onClick }),
      ...(id && { id }),
    }),
    [id],
  );

  const content = (
    <>
      <div data-testid="content-wrap" data-element="content-wrap">
        {typeof image === 'string' ? (
          <AccordionContentImage
            image={image}
            title={title}
            fallbackImage={fallbackImage}
            height={35}
            width={35}
          />
        ) : (
          image
        )}

        <div data-testid="content-header" data-element="content-header">
          <div
            className={css({
              display: 'flex',
              gap: 'extra_small_3',
              alignItems: 'center',
            })}
            data-testid="content-title"
            data-element="content-title"
          >
            {title}
            {titleBadge}
          </div>

          <div data-testid="content-subtitle" data-element="content-subtitle">
            {subtitle}
          </div>
        </div>
      </div>

      <div data-element="content-slot">{children}</div>
    </>
  );

  return href ? (
    <Link href={href} prefetch={false} {...commonProps}>
      {content}
    </Link>
  ) : (
    <div {...commonProps}>{content}</div>
  );
};
